import { Oval } from 'react-loader-spinner';
import styled, { useTheme } from 'styled-components';

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FullPageContainer = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;
`;

interface SpinnerLoaderProps {
  width?: string;
  height?: string;
}

export const SpinnerLoader = ({
  width = '60',
  height = '60',
}: SpinnerLoaderProps) => {
  const theme = useTheme();

  // Extract 6 because library has extra margins;
  const sizes = {
    width: String(Number(width) - 6),
    height: String(Number(height) - 6),
  };

  return (
    <Container>
      <Oval
        {...sizes}
        ariaLabel="watch-loading"
        color={theme.colors.white.main}
        secondaryColor={theme.colors.white.active}
      />
    </Container>
  );
};

export const FullPageLoader = () => {
  return (
    <FullPageContainer>
      <SpinnerLoader />
    </FullPageContainer>
  );
};
